import React, {FC, useCallback, useRef, useState} from 'react';
import ReactAudioPlayer from 'react-audio-player';

import './styles.scss';
import playIcon from 'assets/svg/match_player_live_broadcast_play.svg';
import stopIcon from 'assets/svg/match_player_live_broadcast_stop.svg';

const LiveBroadcastPlayer: FC = () => {
  const [canPlay, setCanPlay] = useState(true);
  const [isPlaying, setIsPlaying] = useState(false);
  const player = useRef<ReactAudioPlayer>(null);

  const togglePlay = useCallback(() => {
    if (player.current && player.current.audioEl.current) {
      if (isPlaying) {
        setIsPlaying(false);
        player.current.audioEl.current.pause();
        /* NOTE: the line below (18) fixes the bug in task [SUP-54] */
        player.current.audioEl.current.src = `${process.env.REACT_APP_LIVE_BROADCAST_URL}`;
      } else {
        setIsPlaying(true);
        player.current.audioEl.current.play();
      }
    }
  }, [isPlaying]);

  return (
    <button
      type="button"
      className={`LiveBroadcastPlayer 
      ${isPlaying ? 'LiveBroadcastPlayer--is-playing' : ''}
      ${!canPlay ? 'LiveBroadcastPlayer--hidden' : ''}
      `}
      onClick={() => togglePlay()}
    >
      <img className="LiveBroadcastPlayer__icon"
      src={isPlaying ? stopIcon : playIcon}
      alt={isPlaying ? 'stop' : 'play'} />
      <span className="LiveBroadcastPlayer__label">ΗΧΗΤΙΚΗ ΜΕΤΑΔΟΣΗ</span>
      <ReactAudioPlayer
        ref={player}
        src={process.env.REACT_APP_LIVE_BROADCAST_URL}
        // onCanPlay={() => setCanPlay(true)}
        onError={() => setCanPlay(false)}
      />
    </button>
  );
};
/* NOTE: [line:38] onCanPlay is never fired in safari OSX & iOS and can play never changes to true.
         [SUP-52] to solve the problem changed the initial value of canPlay to true [line:8]
         and comment onCanPlay since is not working in safari.
         Also don't understand why to start with the component hidden [line: 31],
         At the parent component (src/components/Match/HeaderInfo/index.tsx) we check if the hasLiveBroadcast,
         from the match data, is set to true so to print or not the audio!
*/
export default LiveBroadcastPlayer;
